<script setup lang="ts">
defineProps<{
  label: string
  hint?: string
  error?: string
  id?: string
}>()

const model = defineModel<string>()
const inputId = useId()
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label :for="id || inputId" class="text-sm font-semibold text-ink">{{ label }}</label>

    <input
      :id="id || inputId"
      v-model="model"
      v-bind="$attrs"
      class="min-h-13 rounded-control border bg-surface px-4 text-[15px] text-ink outline-none transition placeholder:text-muted-ink focus:border-terracotta focus:ring-2 focus:ring-terracotta/20"
      :class="error ? 'border-terracotta' : 'border-line'"
    >

    <p v-if="error" class="text-sm text-terracotta">{{ error }}</p>
    <p v-else-if="hint" class="text-sm text-ink-faint">{{ hint }}</p>
  </div>
</template>
